import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from 'src/app/app.component';
import { AuthService } from 'src/app/utility/auth/auth.service';

import {
  MarkdownDetailComponent,
  MarkdownEditComponent,
  MarkdownListComponent,
  ProjectListComponent
} from '@serengeti/serengeti-board';
import { ProjectDetailComponent } from '@serengeti/serengeti-board';
import { ProjectEditComponent } from '@serengeti/serengeti-board';
import { NoticeListComponent } from '@serengeti/serengeti-board';
import { NoticeDetailComponent } from '@serengeti/serengeti-board';
import { NoticeEditComponent } from '@serengeti/serengeti-board';
import { FAQListComponent } from '@serengeti/serengeti-board';
import { FAQDetailComponent } from '@serengeti/serengeti-board';
import { FAQEditComponent } from '@serengeti/serengeti-board';
import { QnAListComponent } from '@serengeti/serengeti-board';
import { QnAEditComponent } from '@serengeti/serengeti-board';
import { QnADetailComponent } from '@serengeti/serengeti-board';

import { SurveyDetailComponent, SurveyListComponent, SurveyResultComponent } from '@serengeti/serengeti-survey';

const routes: Routes = [
	{ path: 'main', component: AppComponent, canActivate: [AuthService], children: [
		{ path: 'project/list', component: ProjectListComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'board.project.list.title.total', root: true }},
		{ path: 'project/detail/:contentId', component: ProjectDetailComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'board.project.detail.title', root: false }},
		{ path: 'project/edit', component: ProjectEditComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'board.project.edit.title.create', root: false }},
		{ path: 'project/edit/:contentId', component: ProjectEditComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'board.project.edit.title.update', root: false }},

		{ path: 'notice/list', component: NoticeListComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'board.notice.list.title', root: true } },
		{ path: 'notice/detail/:contentId', component: NoticeDetailComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.notice.detail.title', root: false }},
		{ path: 'notice/edit/:userId', component: NoticeEditComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.notice.edit.title.create', root: false }},
		{ path: 'notice/edit/:userId/:contentId', component: NoticeEditComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.notice.edit.title.update', root: false }},

      { path: 'markdown/list', component: MarkdownListComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'board.markdown.list.title', root: true } },
      { path: 'markdown/detail/:contentId', component: MarkdownDetailComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.markdown.detail.title', root: false }},
      { path: 'markdown/edit/:userId', component: MarkdownEditComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.notice.edit.title.create', root: false }},
      { path: 'markdown/edit/:userId/:contentId', component: MarkdownEditComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.notice.edit.title.update', root: false }},

		{ path: 'qna/list', component:QnAListComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.qna.list.title', root: true }},
		{ path: 'qna/detail/:qnaId', component:QnADetailComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.qna.detail.title', root: false }},
		{ path: 'qna/edit', component:QnAEditComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.qna.list.title', root: true }},

		{ path: 'faq/list', component:FAQListComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.faq.list.title', root: true }},
		{ path: 'faq/detail/:contentId', component:FAQDetailComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.faq.detail.title', root: false }},
		{ path: 'faq/edit/:userId', component:FAQEditComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.faq.edit.title.create', root: false }},
		{ path: 'faq/edit/:userId/:contentId', component:FAQEditComponent, outlet: 'content' , canActivate: [AuthService], data: { title: 'board.faq.edit.title.update', root: false }},

        { path: 'survey/list', component: SurveyListComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'survey.list.title', root: true }},
		{ path: 'survey/detail/:surveyId', component: SurveyDetailComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'survey.detail.title', root: false }},
		{ path: 'survey/result/:surveyId', component: SurveyResultComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'survey.result.title', root: false }},
	]},
];

@NgModule({
	declarations: [],
	imports: [
		RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true }),
		CommonModule
	]
})
export class AppRoutingBoardModule { }
